<div class="asset-file-info-container">
  <div class="header rounded-lg flex flex-row sticky top-0 asset-details p-4 z-50 items-center">
    <h2 class="asset-details-title text-xl font-bold" i18n>Asset data</h2>
  </div>
  <!-- general data -->
  <div class="details px-4">
    <div class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
      <span class="w-2/5 field-label dataset-entry-label">ID</span>
      <div class="dataset-entry-value inline-block w-3/5">
        <span>{{ assetInfo._id }}</span>
      </div>
    </div>
    <div *ngIf="brandingKey === CustomClients.VKB && assetInfo.idExternal" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
      <span class="w-2/5 field-label dataset-entry-label">Alte Asset ID</span>
      <div class="dataset-entry-value inline-block w-3/5">
        <span>{{ assetInfo.idExternal }} </span>
      </div>
    </div>
    <div class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
      <span class="w-2/5 field-label dataset-entry-label" i18n>Asset type</span>
      <p class="dataset-entry-value inline-block w-3/5">
        <span>{{ assetInfo.assetType | assetTypeTranslation }}</span>
      </p>
    </div>
    <div class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
      <span class="w-2/5 field-label dataset-entry-label" i18n>File type</span>
      <p class="dataset-entry-value inline-block w-3/5">
        <span>{{ assetInfo.mainFile.ext | formatFileTypes: brandingKey }}</span>
      </p>
    </div>
    <div class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
      <span class="w-2/5 field-label dataset-entry-label" i18n>Size</span>
      <p class="dataset-entry-value inline-block w-3/5">
        <span>{{ assetInfo.mainFile.size | formatFileSize }}</span>
      </p>
    </div>
    <div class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }" *ngIf="heightString">
      <span class="w-2/5 field-label dataset-entry-label" i18n>Width</span>
      <p class="dataset-entry-value inline-block w-3/5">
        <span>{{ heightString }}</span>
      </p>
    </div>
    <div class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }" *ngIf="widthString">
      <span class="w-2/5 field-label dataset-entry-label" i18n>Height</span>
      <p class="dataset-entry-value inline-block w-3/5">
        <span>{{ widthString }}</span>
      </p>
    </div>
    <ng-container [ngSwitch]="assetInfo.assetType">
      <!-- IMAGE -->
      <div *ngSwitchCase="AssetTypes.Image">
        <div *ngIf="metadata.density && ![CustomClients.Arval.toString()].includes(brandingKey)" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Density</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.density }} ppi</span>
          </p>
        </div>
        <div *ngIf="metadata.space" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Color</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.space.toUpperCase() }}</span>
          </p>
        </div>
        <div *ngIf="brandingKey === CustomClients.VKB && metadata.icc && metadata.icc.colorSpace" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Farbraum</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.icc.colorSpace.toUpperCase() }}</span>
          </p>
        </div>
      </div>
      <!-- VIDEO -->
      <div *ngSwitchCase="AssetTypes.Video">
        <div class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Duration</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ durationString | spTimeFormat }} </span>
          </p>
        </div>
        <div *ngIf="metadata.space" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Codec</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.codec_name }}</span>
          </p>
        </div>
        <div *ngIf="metadata.space" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Framerate</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.avg_frame_rate }}</span>
          </p>
        </div>
        <div *ngIf="brandingKey === CustomClients.VKB && metadata.color_space" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Farbraum</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.color_space.toUpperCase() }}</span>
          </p>
        </div>
      </div>
      <!-- HTML Banner -->
      <div *ngSwitchCase="AssetTypes.HtmlBanner">
        <div *ngIf="metadata.adServerName" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Ad-server Name</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.adServerName }}</span>
          </p>
        </div>
        <div *ngIf="metadata.master" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Master</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.master }}</span>
          </p>
        </div>
        <div *ngIf="metadata.motif" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Motif</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.motif }}</span>
          </p>
        </div>
        <div *ngIf="metadata.lang" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Language</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.lang }}</span>
          </p>
        </div>
        <div *ngIf="metadata.bannerMetadata?.height" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Height</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.bannerMetadata.height }} px</span>
          </p>
        </div>
        <div *ngIf="metadata.bannerMetadata?.width" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Width</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.bannerMetadata.width }} px</span>
          </p>
        </div>
      </div>
      <!-- AUDIO -->
      <div *ngSwitchCase="AssetTypes.Audio">
        <div class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Duration</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ durationString | spTimeFormat }} </span>
          </p>
        </div>
        <div *ngIf="metadata.bit_rate" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Bitrate</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.bit_rate }}</span>
          </p>
        </div>
        <div *ngIf="metadata.sample_rate" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Sample rate</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.sample_rate }}</span>
          </p>
        </div>
        <div *ngIf="metadata.bits_per_sample" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
          <span class="w-2/5 field-label dataset-entry-label" i18n>Bits per sample</span>
          <p class="dataset-entry-value inline-block w-3/5">
            <span>{{ metadata.bits_per_sample }}</span>
          </p>
        </div>
      </div>
    </ng-container>
    <div *ngIf="brandingKey === CustomClients.VKB && customFields && customFields.pressureProfile" class="dataset-entry flex items-start" [ngClass]="{ 'my-2': isCustomClients }">
      <span class="w-2/5 field-label dataset-entry-label" i18n
        >Farbprofil
        <sup class="text-[#1212128F] cursor-pointer"
          ><mat-icon
            matTooltip='Das Farbprofil gibt an, ob das Bild für den Druck (CMYK + "39L") oder für digitale Nutzung (RGB + sRGB) gedacht ist, um überall die bestmögliche Farbdarstellung zu gewährleisten.'
            matTooltipClass="tooltip-list"
            >info</mat-icon
          ></sup
        ></span
      >
      <p class="dataset-entry-value inline-block w-3/5">
        <span>{{ customFields.pressureProfile }}</span>
      </p>
    </div>
  </div>
</div>
<thehubz-asset-notifications [asset]="assetInfo"></thehubz-asset-notifications>
